import Business from '../Sellpoint/index.vue' //BusinessView
import Settings from '../Settings/index.vue' //SeetingsView
import Refer from '../Refer/index.vue' //ReferView
import Help from '../Help/index.vue' //HelpView
//
import Account from '../Sellpoint/script.js' //scripts


export default {
    name: 'Account',
    mixins: [Account],
    data () {
        return {
            
        }
    },

    components: {
        'business-view': Business,
        'settings': Settings,
        'help-view': Help,
        'refer-view': Refer,
    },
     
    methods: {

        backTo(){
            window.history.back(); 
        },
      
    },

    created: function(){
        this.loading = true;
        let self = this;
        //setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Template/script.js